import {
  DELETE_AFFILIATE_REQUEST,
  DELETE_AFFILIATE_SUCCESS,
  DELETE_AFFILIATE_FAILURE,
} from '../../actions/adminAffiliates/adminAffliatesActionType';

const initialState = {
  loading: false,
  affiliate: [],
  error: '',
  fetched: false,
};
interface Payload {
  AppUserID: number;
  AffiliateName: Array<string>;
  UserName: string;
  Email: string;
  Detail: any;
}
interface AdminDeleteAction {
  payload: Payload;
  type: string;
}

const deleteAffiliateReducer = ( state = initialState, action: AdminDeleteAction):any => {
  switch (action.type) {
    case DELETE_AFFILIATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_AFFILIATE_SUCCESS:
      return {
        ...state,
        loading: false,
        affiliate: action.payload,
        error: '',
        fetched: true,
      };
    case DELETE_AFFILIATE_FAILURE:
      return {
        ...state,
        loading: false,
        affiliate: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default deleteAffiliateReducer;
